(function () {
  var root = document.documentElement;
  var preloader = document.getElementById('tw-preloader');
  if (!preloader) return;

  var MOBILE_MQ = window.matchMedia('(max-width: 989px)');
  var countEl = preloader.querySelector('.tw-preloader__count');
  var transition = resolveTransition(preloader);
  var scrollLockRaf = null;
  var frameImages = [];
  var framesPreloadStarted = false;

  function resolveTransition(rootEl) {
    var mobileFrames = resolveMobileFrames(rootEl);
    if (mobileFrames) {
      return { type: 'frames', frames: mobileFrames };
    }

    return { type: 'video', video: resolveTransitionVideo(rootEl) };
  }

  function resolveMobileFrames(rootEl) {
    if (!MOBILE_MQ.matches) return null;

    var configEl = rootEl.querySelector('[data-preloader-mobile-frames]');
    var canvas = rootEl.querySelector('.tw-preloader__frames--mobile');
    if (!(configEl instanceof HTMLScriptElement) || !(canvas instanceof HTMLCanvasElement)) {
      return null;
    }

    var urls = [];
    try {
      urls = JSON.parse(configEl.textContent || '[]');
    } catch (err) {
      return null;
    }

    if (!Array.isArray(urls) || !urls.length) return null;

    var fps = parseFloat(rootEl.getAttribute('data-mobile-frames-fps') || '30');
    if (isNaN(fps) || fps <= 0) fps = 30;

    return { canvas: canvas, urls: urls, fps: fps };
  }

  function resolveTransitionVideo(rootEl) {
    var isMobile = MOBILE_MQ.matches;
    var mobileVideo = rootEl.querySelector('.tw-preloader__transition--mobile');
    var desktopVideo = rootEl.querySelector('.tw-preloader__transition--desktop');

    if (isMobile && mobileVideo) return mobileVideo;
    if (desktopVideo) return desktopVideo;
    if (mobileVideo) return mobileVideo;
    return rootEl.querySelector('.tw-preloader__transition');
  }

  function startFramePreload() {
    if (transition.type !== 'frames' || framesPreloadStarted) return;
    framesPreloadStarted = true;

    transition.frames.urls.forEach(function (url, index) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = img.onerror = function () {
        frameImages[index] = img;
      };
      img.src = url;
    });
  }

  function drawFrameCover(ctx, canvas, img) {
    var cw = canvas.width;
    var ch = canvas.height;
    if (!cw || !ch || !img.naturalWidth || !img.naturalHeight) return;

    var scale = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
    var dw = img.naturalWidth * scale;
    var dh = img.naturalHeight * scale;
    var dx = (cw - dw) / 2;
    var dy = (ch - dh) / 2;

    ctx.clearRect(0, 0, cw, ch);
    ctx.drawImage(img, dx, dy, dw, dh);
  }

  function resizeFrameCanvas(canvas) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(window.innerWidth * dpr);
    canvas.height = Math.round(window.innerHeight * dpr);
    canvas.style.width = '100%';
    canvas.style.height = '100%';
  }

  function playFrameSequence(frames, onComplete) {
    var canvas = frames.canvas;
    var ctx = canvas.getContext('2d');
    if (!ctx) {
      onComplete();
      return;
    }

    resizeFrameCanvas(canvas);

    var frameIndex = 0;
    var lastTime = 0;
    var frameDuration = 1000 / frames.fps;
    var rafId = null;

    function drawCurrentFrame() {
      var img = frameImages[frameIndex];
      if (img && img.complete && img.naturalWidth) {
        drawFrameCover(ctx, canvas, img);
      }
    }

    function tick(now) {
      if (!lastTime) lastTime = now;
      var elapsed = now - lastTime;

      if (elapsed >= frameDuration) {
        var steps = Math.floor(elapsed / frameDuration);
        frameIndex += steps;
        lastTime += steps * frameDuration;

        if (frameIndex >= frames.urls.length) {
          drawCurrentFrame();
          onComplete();
          return;
        }

        drawCurrentFrame();
      }

      rafId = window.requestAnimationFrame(tick);
    }

    drawCurrentFrame();
    rafId = window.requestAnimationFrame(tick);

    return function cancel() {
      if (rafId) window.cancelAnimationFrame(rafId);
    };
  }

  function getScrollContainer() {
    var pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper instanceof HTMLElement) return pageWrapper;
    var scrollingEl = document.scrollingElement;
    return scrollingEl instanceof HTMLElement ? scrollingEl : root;
  }

  function resetScrollPosition() {
    var scroller = getScrollContainer();
    if (scroller.scrollTop !== 0) scroller.scrollTop = 0;
    if (window.scrollY !== 0) window.scrollTo(0, 0);
  }

  function preventScrollEvent(event) {
    event.preventDefault();
  }

  function preventScrollKeys(event) {
    var target = event.target;
    if (
      target instanceof HTMLElement &&
      (target.isContentEditable ||
        target.closest('input, textarea, select, [contenteditable="true"]'))
    ) {
      return;
    }

    var blockedKeys = [
      'ArrowUp',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'PageUp',
      'PageDown',
      'Home',
      'End',
      ' ',
    ];

    if (blockedKeys.indexOf(event.key) >= 0) {
      event.preventDefault();
    }
  }

  function watchScrollPosition() {
    if (!root.classList.contains('tw-preloader-active')) return;
    resetScrollPosition();
    scrollLockRaf = window.requestAnimationFrame(watchScrollPosition);
  }

  function lockScroll() {
    root.classList.add('tw-preloader-active');
    root.setAttribute('scroll-lock', '');
    resetScrollPosition();

    window.addEventListener('wheel', preventScrollEvent, { passive: false, capture: true });
    window.addEventListener('touchmove', preventScrollEvent, { passive: false, capture: true });
    window.addEventListener('keydown', preventScrollKeys, { capture: true });
    getScrollContainer().addEventListener('scroll', resetScrollPosition, { passive: true });

    if (scrollLockRaf) window.cancelAnimationFrame(scrollLockRaf);
    scrollLockRaf = window.requestAnimationFrame(watchScrollPosition);
  }

  function unlockScroll() {
    root.classList.remove('tw-preloader-active');
    root.removeAttribute('scroll-lock');

    window.removeEventListener('wheel', preventScrollEvent, true);
    window.removeEventListener('touchmove', preventScrollEvent, true);
    window.removeEventListener('keydown', preventScrollKeys, true);
    getScrollContainer().removeEventListener('scroll', resetScrollPosition);

    if (scrollLockRaf) {
      window.cancelAnimationFrame(scrollLockRaf);
      scrollLockRaf = null;
    }

    document.body.style.removeProperty('position');
    document.body.style.removeProperty('height');
    document.body.style.removeProperty('width');
    resetScrollPosition();

    if (window.TorqWarsSmoothScroll) {
      if (typeof window.TorqWarsSmoothScroll.activateAfterPreloader === 'function') {
        window.TorqWarsSmoothScroll.activateAfterPreloader();
      } else if (typeof window.TorqWarsSmoothScroll.resync === 'function') {
        window.TorqWarsSmoothScroll.resync();
      }
      if (typeof window.TorqWarsSmoothScroll.scheduleRefresh === 'function') {
        window.TorqWarsSmoothScroll.scheduleRefresh();
      }
    }

    window.dispatchEvent(new CustomEvent('tw-preloader-finished'));
  }

  lockScroll();
  startFramePreload();

  if (transition.type === 'video' && transition.video) {
    transition.video.load();
  }

  var total = 0;
  var loaded = 0;
  var target = 0;
  var displayed = 0;
  var windowLoaded = false;
  var raf = null;

  function trackResources() {
    var nodes = document.querySelectorAll('img[src], link[rel="stylesheet"][href], script[src]');
    total = nodes.length;

    if (total === 0) {
      target = 90;
      return;
    }

    nodes.forEach(function (node) {
      if (node.tagName === 'IMG' && node.complete) {
        onResourceSettled();
        return;
      }

      node.addEventListener('load', onResourceSettled, { once: true });
      node.addEventListener('error', onResourceSettled, { once: true });
    });
  }

  function onResourceSettled() {
    loaded = Math.min(loaded + 1, total);
    var pct = total > 0 ? Math.round((loaded / total) * 100) : 90;
    target = Math.min(windowLoaded ? 100 : 99, pct);
  }

  function animate() {
    if (displayed < target) {
      displayed += Math.max(1, Math.ceil((target - displayed) / 6));
      if (displayed > target) displayed = target;
    }

    if (windowLoaded && loaded >= total) {
      displayed = Math.min(displayed + 2, 100);
    }

    var text = displayed < 10 ? '0' + displayed : String(displayed);
    if (countEl) countEl.textContent = text;

    if (windowLoaded && displayed >= 100) {
      if (countEl) countEl.textContent = '100';
      playTransition();
      return;
    }

    raf = window.requestAnimationFrame(animate);
  }

  function playTransition() {
    if (raf) window.cancelAnimationFrame(raf);
    preloader.setAttribute('data-state', 'transition');

    if (transition.type === 'frames') {
      playFrameSequence(transition.frames, finish);
      return;
    }

    var videoEl = transition.video;
    if (!videoEl || !videoEl.querySelector('source[src]')) {
      finish();
      return;
    }

    var settled = false;
    var revealAt = parseFloat(preloader.getAttribute('data-reveal-at') || '');
    var endAt = parseFloat(preloader.getAttribute('data-end-at') || '');
    var hasRevealAt = !isNaN(revealAt) && revealAt > 0;
    var hasEndAt = !isNaN(endAt) && endAt > 0;
    var revealed = false;

    var settle = function () {
      if (settled) return;
      settled = true;
      try {
        videoEl.pause();
      } catch (err) {}
      finish();
    };

    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.playsInline = true;

    videoEl.addEventListener('ended', settle, { once: true });
    videoEl.addEventListener('error', settle, { once: true });

    if (hasRevealAt || hasEndAt) {
      videoEl.addEventListener('timeupdate', function onTimeUpdate() {
        if (settled) {
          videoEl.removeEventListener('timeupdate', onTimeUpdate);
          return;
        }

        var t = videoEl.currentTime;

        if (hasRevealAt && !revealed && t >= revealAt) {
          revealed = true;
          preloader.setAttribute('data-state', 'reveal');
        }

        if (hasEndAt && t >= endAt) {
          videoEl.removeEventListener('timeupdate', onTimeUpdate);
          settle();
        }
      });
    }

    var startTimeout = window.setTimeout(settle, 1500);

    videoEl.addEventListener(
      'playing',
      function () {
        window.clearTimeout(startTimeout);
        var duration = videoEl.duration;
        var cutoff = hasEndAt ? Math.min(endAt, duration || endAt) : duration;
        var maxWait =
          isFinite(cutoff) && cutoff > 0 ? cutoff * 1000 + 500 : 4000;
        window.setTimeout(settle, maxWait);
      },
      { once: true }
    );

    var playPromise = videoEl.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(settle);
    }
  }

  function finish() {
    preloader.setAttribute('data-state', 'done');
    window.setTimeout(function () {
      unlockScroll();
      if (preloader && preloader.parentNode) {
        preloader.parentNode.removeChild(preloader);
      }
    }, 550);
  }

  window.addEventListener('load', function () {
    windowLoaded = true;
    target = 100;
  });

  window.setTimeout(function () {
    windowLoaded = true;
    target = 100;
  }, 8000);

  trackResources();
  raf = window.requestAnimationFrame(animate);
})();
